module.exports = __webpack_public_path__ + "static/home1-2639c1b4b230d769bd958043f4ac5f9e.jpg";